import Vue from 'vue';
import 'reflect-metadata';
import { decorate, injectable } from 'inversify';

decorate(injectable(), Vue);
